import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@promo-platform/error-message';
import { FieldHead } from '@promo-platform/field-head';
import { useFormContext } from 'react-hook-form';

const SingleAnswerItem = ({ label, value, groupAlias, isRequired, isSelected, id, }) => {
    const { register } = useFormContext();
    return (jsxs("div", Object.assign({ className: "single-answer__item" }, { children: [jsx("input", Object.assign({}, register(groupAlias, {
                required: isRequired && isRequired.errorMessage,
            }), { id: `${id}-${value}`, type: "radio", value: value, defaultChecked: isSelected, className: "single-answer__input" })), jsx("label", Object.assign({ htmlFor: `${id}-${value}`, className: "single-answer__label" }, { children: label }))] })));
};

const SingleAnswer = ({ alias, id, label, description, options, }) => {
    var _a;
    const { formState: { errors }, } = useFormContext();
    return (jsxs("div", Object.assign({ className: "single-answer" }, { children: [jsx(FieldHead, { id: id, label: label, description: description }), jsx(ErrorMessage, { message: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message }), jsx("div", Object.assign({ className: "single-answer__items" }, { children: options.map((item) => (jsx(SingleAnswerItem, { groupAlias: alias, label: item.label, value: item.value, isSelected: item.isSelected, id: id }, item.value))) }))] })));
};

export { SingleAnswer };
